import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import PortsSection from "./components/PortsSection";
import UrbanRural from "./components/UrbanRural";
import FarmPanorama from "./components/FarmPanorama";
import ValuesSection from "./components/ValuesSection";
import ThemeGardens from "./components/ThemeGardens";
import AboutSection from "./components/AboutSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <PortsSection />
        <UrbanRural />
        <FarmPanorama />
        <ValuesSection />
        <ThemeGardens />
        <AboutSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}